import { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, makeStyles, ButtonBase } from '@material-ui/core';
import _ from 'lodash';
import Dialog from '../../../../../../components/Dialog';
import Text from '../../../../../../components/Text';
import TitleBox from '../../../../../Admission/components/TitleBox.js';
import StyleInput from '../../../../../../components/StyleInput';
import { AutoCompleteSelect } from '../../../../../../components';
import { AddIcon, RemarksBgIcon } from '../../../../../../components/Icon';
import { classNames } from '../../../../../../utils';
import { eadmissionAPI, systemAPI } from '../../../../../../apis';
import { specialtyMapping, subSpecialtyMapping } from '../../constant';
import { AddWardPop } from '../../../Pops';
import AutoCompleteInput from '../../../../../../components/AutoCompleteInput';
import { NEW_BED_STATUS_CUBICLE_ITEM_LIST } from '../../../../../../comm/constant';
import MappingPopups from './MappingPopups/index.js';

const useStyles = makeStyles((theme) => ({
  star: {
    color: '#FF0300',
    fontSize: '0.875rem',
  },
  btn: {
    color: '#538FFF',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Bold',
    height: '1.375rem',
  },
  addIcon: {
    fontSize: '1rem',
    marginRight: '0.38rem',
  },
  step: {
    display: 'flex',
    position: 'relative',
    '&::before': {
      position: 'absolute',
      left: '-2.19rem',
      top: '0',
      content: '""',
      width: '1.5rem',
      height: '1.5rem',
      borderRadius: '50%',
      backgroundColor: '#FBEADB',
      border: `2px solid #FBEADB`,
      zIndex: 1,
    },
    '&::after': {
      position: 'absolute',
      left: '-1.44rem',
      top: '1.5rem',
      content: '""',
      borderLeft: `2px solid #EFAA7E`,
      height: '100%',
      zIndex: 0,
      transform: 'translateX(-50%)',
    },
    '&.hideStep::after': {
      display: 'none',
    },
    '&.IsolationRoom:after': {
      borderLeft: `2px solid #FECA06`,
    },
    '&.IsolationRoom:before': {
      display: 'none',
    },
  },
  brown: {
    '&::before': {
      backgroundColor: '#FBEADB',
      border: ` 2px solid #EFAA7E`,
    },
    '&::after': {
      borderLeft: `2px solid #EFAA7E`,
    },
  },
  brownSolid: {
    '&::before': {
      backgroundColor: '#EFAA7E',
      border: ` 2px solid #EFAA7E`,
    },
    '&::after': {
      borderLeft: `2px solid #EFAA7E`,
    },
  },
  yellow: {
    '&::before': {
      backgroundColor: '#FFF2C1',
      border: ` 2px solid #FECA06`,
    },
    '&::after': {
      borderLeft: `2px solid #FECA06`,
    },
  },
  yellowSolid: {
    '&::before': {
      backgroundColor: '#FECA06',
      border: ` 2px solid #FECA06`,
    },
    '&::after': {
      borderLeft: `2px solid #FECA06`,
    },
  },
  green: {
    '&::before': {
      backgroundColor: '#E4F1D3',
      border: ` 2px solid #92C951`,
    },
    '&::after': {
      borderLeft: `2px solid #92C951`,
    },
  },
  completedBox: {
    marginTop: '2.071rem',
    display: 'flex',
    flexDirection: 'column',
    gridGap: '0.62rem',
    background: 'rgba(112, 144, 176, 0.20)',
    borderRadius: '10px',
    padding: '1.285rem 1.642rem',
    width: 'fit-content',
  },
}));

const EditWorkflow = ({ handleClose, handleAfterSave }) => {
  const classes = useStyles();
  const [form, setForm] = useState({
    admWardId: '',
    aedWardId: '',
    defaultWardAssignByWardId: '',
    eaedHospCode: '',
    eaedSpecialtyDdlMap: '',
    eaedSubSpecialtyTxtboxMap: '',
    exWardLocStatus: [''],
    isAdmReadyReq: '',
    isWardReadyReq: '',
    isWardAssReq: 'Y',
    isWardAckReq: 'Y',
    isBusStopLineReq: 'Y',
    isWardAllowedRedirect: 'Y',
    isolroomCubtype: [
      {
        cubicleType: '',
        subTypeName: '',
      },
      {
        cubicleType: '',
        subTypeName: '',
      },
      {
        cubicleType: '',
        subTypeName: '',
      },
    ],
    porterDispatchBy: '',
    wardAssignTitle: '',
    aedDischgPosition: 'APD',
    completed: '',
  });
  const [isolroomCubtype, setIsolroomCubtype] = useState({
    isolroomCubtypeA: [
      {
        cubicleType: 'A',
        subTypeName: '',
        id: 1,
      },
    ],
    isolroomCubtypeR: [
      {
        cubicleType: 'R',
        subTypeName: '',
        id: 1,
      },
    ],
    isolroomCubtypeS: [
      {
        cubicleType: 'S',
        subTypeName: '',
        id: 1,
      },
    ],
  });
  const [exWardLocStatus, setExWardLocStatus] = useState([
    {
      value: '',
      id: 1,
    },
  ]);
  const [assignedTitle, setAssignedTitle] = useState([]);
  const [porterList, setPorterList] = useState([]);
  const [wardItemList, setWardItemList] = useState([]);
  const [addUnit, setAddUnit] = useState(false);
  const [mapPopOpen, setMapPopOpen] = useState(false);
  const hideStep = useMemo(() => '', [form.isBusStopLineReq]);

  const getWorkflowDetail = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getWorkflowDetail();
      if (!result.WorkflowDetail || JSON.stringify(result.WorkflowDetail) === '{}') {
        return;
      }
      setForm(result.WorkflowDetail);
      if (result.WorkflowDetail.exWardLocStatus.length > 0) {
        setExWardLocStatus(
          _.map(result.WorkflowDetail.exWardLocStatus, (item, index) => ({
            value: item.exWardLocStatus,
            id: index,
          }))
        );
      }
      setIsolroomCubtype(() => {
        let isolroomCubtypeA = _.filter(result.WorkflowDetail.isolroomCubtype, (item) => item.cubicleType === 'A').map(
          (item, index) => ({
            cubicleType: 'A',
            subTypeName: item.subTypeName,
            id: index,
          })
        );
        let isolroomCubtypeR = _.filter(result.WorkflowDetail.isolroomCubtype, (item) => item.cubicleType === 'R').map(
          (item, index) => ({
            cubicleType: 'R',
            subTypeName: item.subTypeName,
            id: index,
          })
        );

        let isolroomCubtypeS = _.filter(result.WorkflowDetail.isolroomCubtype, (item) => item.cubicleType === 'S').map(
          (item, index) => ({
            cubicleType: 'S',
            subTypeName: item.subTypeName,
            id: index,
          })
        );

        if (isolroomCubtypeA.length === 0) {
          isolroomCubtypeA = [
            {
              cubicleType: 'A',
              subTypeName: '',
              id: 1,
            },
          ];
        }

        if (isolroomCubtypeR.length === 0) {
          isolroomCubtypeR = [
            {
              cubicleType: 'R',
              subTypeName: '',
              id: 1,
            },
          ];
        }

        if (isolroomCubtypeS.length === 0) {
          isolroomCubtypeA = [
            {
              cubicleType: 'S',
              subTypeName: '',
              id: 1,
            },
          ];
        }

        return {
          isolroomCubtypeA,
          isolroomCubtypeR,
          isolroomCubtypeS,
        };
      });
    } catch (error) {}
  }, []);

  useEffect(() => {
    getWorkflowDetail();
  }, [getWorkflowDetail]);

  const handleAddWardLocStatus = () => {
    setExWardLocStatus((o) => [
      ...o,
      {
        value: '',
        id: o[o.length - 1].id + 1,
      },
    ]);
  };

  const updateFormValue = (key, value) => {
    setForm((o) => ({
      ...o,
      [key]: value,
    }));
  };

  const updateForm =
    ({ key, id }) =>
    (value) => {
      switch (key) {
        case 'eaedHospCode':
        case 'aedWardId':
        case 'isAdmReadyReq':
        case 'wardAssignTitle':
        case 'defaultWardAssignByWardId':
        case 'eaedSpecialtyDdlMap':
        case 'eaedSubSpecialtyTxtboxMap':
        case 'isWardReadyReq':
        case 'admWardId':
        case 'porterDispatchBy':
        case 'isWardAckReq':
        case 'aedDischgPosition':
        case 'isBusStopLineReq':
        case 'isWardAllowedRedirect':
        case 'completed':
          updateFormValue(key, value);
          break;
        case 'isWardAssReq':
          setForm((o) => ({
            ...o,
            isWardAssReq: value,
            isWardAckReq: value === 'Y' ? o.isWardAckReq : 'N',
            isWardReadyReq: value === 'Y' ? o.isWardReadyReq : 'N',
          }));
          break;
        case 'exWardLocStatus':
          setExWardLocStatus((o) =>
            _.map(o, (item) => ({
              ...item,
              value: item.id === id ? value : item.value,
            }))
          );
          break;
        case 'isolroomCubtypeA':
        case 'isolroomCubtypeR':
        case 'isolroomCubtypeS':
          setIsolroomCubtype((o) => ({
            ...o,
            [key]: _.map(o[key], (item) => ({
              ...item,
              subTypeName: item.id === id ? value : item.subTypeName,
            })),
          }));
          break;
        default:
          break;
      }
    };

  const getAssignedTitle = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getAssignedTitle();
      setAssignedTitle(result.wardAssignedTitle);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getSysWardItemList = useCallback(async () => {
    try {
      const { result } = await systemAPI.getSysWardItemList();
      setWardItemList(result?.[0]?.wards);
    } catch (error) {}
  }, []);

  const getPorterList = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getPorterList();
      setPorterList(result.porterDispatch);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getAssignedTitle();
    getPorterList();
    getSysWardItemList();
  }, [getAssignedTitle, getPorterList, getSysWardItemList]);

  const dropdownOptions = useMemo(() => {
    const ynOptions = [
      {
        text: 'Yes',
        value: 'Y',
      },
      {
        text: 'No',
        value: 'N',
      },
    ];

    const assignedTitleOptions = _.map(assignedTitle, (item) => ({
      text: item.name,
      value: item.name,
    }));

    const porterListOptions = _.map(porterList, (item) => ({
      text: item.name,
      value: item.name,
    }));

    const wardItemOptions = _.map(wardItemList, (item) => ({
      text: item.wardName,
      value: item.wardId,
    }));

    const aedDischgPositionOptions = [
      {
        text: 'After Porter Dispatch',
        value: 'APD',
      },
      {
        text: 'After Admission Registration',
        value: 'AAR',
      },
      {
        text: 'After Ward Ready',
        value: 'AWR',
      },
    ];

    const caseStatusCompletedAtOptions = [
      {
        text: 'AED Discharged',
        value: 'AED_DC',
      },
      {
        text: 'Bed Assigned',
        value: 'BED_ASS',
      },
    ];

    return {
      ynOptions,
      assignedTitleOptions,
      porterListOptions,
      wardItemOptions,
      aedDischgPositionOptions,
      caseStatusCompletedAtOptions,
    };
  }, [assignedTitle, porterList, wardItemList]);

  useEffect(() => {
    setForm((o) => ({
      ...o,
      exWardLocStatus: _.filter(
        _.map(exWardLocStatus, (item) => item.value),
        (item) => item
      ),
    }));
  }, [exWardLocStatus]);

  useEffect(() => {
    setForm((o) => ({
      ...o,
      isolroomCubtype: _.filter(
        [
          ..._.map(isolroomCubtype.isolroomCubtypeA, (item) => ({
            cubicleType: item.cubicleType,
            subTypeName: item.subTypeName,
          })),
          ..._.map(isolroomCubtype.isolroomCubtypeR, (item) => ({
            cubicleType: item.cubicleType,
            subTypeName: item.subTypeName,
          })),
          ..._.map(isolroomCubtype.isolroomCubtypeS, (item) => ({
            cubicleType: item.cubicleType,
            subTypeName: item.subTypeName,
          })),
        ],
        (item) => item.subTypeName
      ),
    }));
  }, [isolroomCubtype]);

  const disabledSave = useMemo(
    () =>
      form.isWardAssReq === 'Y'
        ? Boolean(form.aedWardId) &&
          Boolean(form.isAdmReadyReq) &&
          Boolean(form.wardAssignTitle) &&
          Boolean(form.isWardReadyReq) &&
          Boolean(form.admWardId) &&
          Boolean(form.porterDispatchBy) &&
          Boolean(form.isWardAssReq) &&
          Boolean(form.isWardAckReq) &&
          Boolean(form.isBusStopLineReq) &&
          Boolean(form.aedDischgPosition)
        : Boolean(form.aedWardId) &&
          Boolean(form.isAdmReadyReq) &&
          Boolean(form.isWardReadyReq) &&
          Boolean(form.admWardId) &&
          Boolean(form.porterDispatchBy) &&
          Boolean(form.isWardAssReq) &&
          Boolean(form.isWardAckReq) &&
          Boolean(form.isBusStopLineReq) &&
          Boolean(form.aedDischgPosition),
    [
      form.aedWardId,
      form.isAdmReadyReq,
      form.wardAssignTitle,
      form.isWardReadyReq,
      form.admWardId,
      form.porterDispatchBy,
      form.isWardAssReq,
      form.isWardAckReq,
      form.isBusStopLineReq,
      form.aedDischgPosition,
    ]
  );

  const disabledWardCalling = useMemo(() => form.isWardAssReq === 'N', [form.isWardAssReq]);

  const handleSave = useCallback(async () => {
    try {
      await eadmissionAPI.editWorkflow(form);
      handleAfterSave();
    } catch (error) {
      console.log(error);
    }
  }, [form, handleAfterSave]);

  const addPopConfirmClick = async (data) => {
    try {
      await systemAPI.createSysWard(data);
      await getSysWardItemList();
      setAddUnit(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Dialog
        open={true}
        title="Edit"
        confirm="Save"
        handleClose={handleClose}
        handleConfirm={handleSave}
        disabled={!disabledSave}
        width="63rem"
        confirmStyle={{ backgroundColor: '#28D2AB' }}
        dialogfootStyle={{ paddingTop: '1.875rem', boxShadow: '0px -1px 0px 0px #E4E7EB', marginTop: '2.5rem' }}
      >
        <Box display="flex" flexDirection="column" width="18rem" gridGap="0.62rem" mb="1.87rem">
          <Text color="#2E4469" fontSize="1rem">
            Is bus stop line required <span className={classes.star}>*</span>
          </Text>
          <AutoCompleteSelect
            itemList={dropdownOptions.ynOptions}
            value={form.isBusStopLineReq}
            onChange={updateForm({ key: 'isBusStopLineReq' })}
            width="18rem"
            placeholder="Select from below"
          />
        </Box>
        <Box ml="2.19rem">
          <Box className={classNames(classes.step, classes.brown, hideStep)} pb="2.5rem">
            <Text fontSize="1rem">Admission Decision</Text>
          </Box>
          <Box
            className={classNames(classes.step, classes.brownSolid, hideStep)}
            display="flex"
            flexDirection="column"
            gridGap="1.25rem"
            pb="2.5rem"
          >
            <Text fontSize="1.25rem" color="#2E4469">
              Admission Ready
            </Text>
            <TitleBox title="My eAED Hosp Code">
              <StyleInput
                value={form.eaedHospCode}
                onChange={updateForm({ key: 'eaedHospCode' })}
                width="18rem"
                placeholder="Input data"
              />
            </TitleBox>
            <Box display="flex" gridGap="1.25rem">
              <Box display="flex" flexDirection="column" alignItems="flex-start" width="18rem" gridGap="0.62rem">
                <Text color="#2E4469" fontSize="1rem">
                  My Hospital&apos;s AED<span className={classes.star}>*</span>
                </Text>
                <AutoCompleteSelect
                  itemList={dropdownOptions.wardItemOptions}
                  value={form.aedWardId}
                  onChange={updateForm({ key: 'aedWardId' })}
                  width="18rem"
                  placeholder="Select from below"
                />
                <ButtonBase className={classes.btn} onClick={() => setAddUnit(true)}>
                  <AddIcon className={classes.addIcon} /> Add Unit
                </ButtonBase>
              </Box>
              <Box display="flex" flexDirection="column" width="18rem" gridGap="0.62rem">
                <Text color="#2E4469" fontSize="1rem">
                  Is admission ready required<span className={classes.star}>*</span>
                </Text>
                <AutoCompleteSelect
                  itemList={dropdownOptions.ynOptions}
                  value={form.isAdmReadyReq}
                  onChange={updateForm({ key: 'isAdmReadyReq' })}
                  placeholder="Select from below"
                />
              </Box>
            </Box>
          </Box>
          <Box
            className={classNames(classes.step, classes.yellowSolid, hideStep)}
            display="flex"
            flexDirection="column"
            gridGap="1.25rem"
            pb="2.5rem"
          >
            <Text fontSize="1.25rem" color="#2E4469">
              Ward Assigned / Calling
            </Text>
            <Box display="flex" flexDirection="column" width="18rem" gridGap="0.62rem">
              <Text color="#2E4469" fontSize="1rem">
                Is ward assigned/calling required <span className={classes.star}>*</span>
              </Text>
              <AutoCompleteSelect
                itemList={dropdownOptions.ynOptions}
                value={form.isWardAssReq}
                onChange={updateForm({ key: 'isWardAssReq' })}
                width="18rem"
                placeholder="Select from below"
              />
            </Box>
            <Box display="flex" gridGap="1.25rem">
              <Box display="flex" flexDirection="column" alignItems="flex-start" width="18rem" gridGap="0.62rem">
                <Text color="#2E4469" fontSize="1rem">
                  Bus Stop Title<span className={classes.star}>*</span>
                </Text>
                <AutoCompleteSelect
                  itemList={dropdownOptions.assignedTitleOptions}
                  value={form.wardAssignTitle}
                  onChange={updateForm({ key: 'wardAssignTitle' })}
                  width="18rem"
                  placeholder="Select from below"
                  disabled={disabledWardCalling}
                />
              </Box>
              <Box display="flex" flexDirection="column" width="18rem" gridGap="0.62rem">
                <Text color="#2E4469" fontSize="1rem">
                  Default Ward Assignment By
                </Text>
                <AutoCompleteSelect
                  itemList={dropdownOptions.wardItemOptions}
                  value={form.defaultWardAssignByWardId}
                  onChange={updateForm({ key: 'defaultWardAssignByWardId' })}
                  placeholder="Select from below"
                  disabled={disabledWardCalling}
                />
              </Box>
              <Box display="flex" flexDirection="column" width="18rem" gridGap="0.62rem">
                <Text color="#2E4469" fontSize="1rem">
                  Is ward allowed to redirect a case<span className={classes.star}>*</span>
                </Text>
                <AutoCompleteSelect
                  itemList={dropdownOptions.ynOptions}
                  value={form.isWardAllowedRedirect}
                  onChange={updateForm({ key: 'isWardAllowedRedirect' })}
                  placeholder="Select from below"
                  disabled={disabledWardCalling}
                />
              </Box>
            </Box>
            <Box display="flex" gridGap="1.25rem">
              <Box display="flex" flexDirection="column" alignItems="flex-start" width="18rem" gridGap="0.62rem">
                <Text color="#2E4469" fontSize="1rem" style={{ height: '2.75rem' }}>
                  Exclude following Ward Location Status for Ward Assignment
                </Text>
                {exWardLocStatus.map((item) => (
                  <AutoCompleteInput
                    freeSolo
                    itemList={NEW_BED_STATUS_CUBICLE_ITEM_LIST.CubicleStatus}
                    value={item.value}
                    onChange={updateForm({ key: 'exWardLocStatus', id: item.id })}
                    placeholder="Input data"
                    width="18rem"
                    key={item.id}
                    disabled={disabledWardCalling}
                  />
                ))}
                <ButtonBase className={classes.btn} onClick={handleAddWardLocStatus} disabled={disabledWardCalling}>
                  <AddIcon className={classes.addIcon} /> Add
                </ButtonBase>
              </Box>
              <Box display="flex" flexDirection="column" pb="1.995rem" width="18rem" gridGap="0.62rem">
                <Box display="flex" alignItems="flex-end" justifyContent="space-between" pr="4rem">
                  <Text
                    color="#2E4469"
                    fontSize="1rem"
                    style={{ display: 'flex', alignItems: 'flex-end', height: '2.75rem' }}
                  >
                    eAED specialty mapping
                  </Text>
                  <ButtonBase onClick={() => setMapPopOpen(true)} disabled={disabledWardCalling}>
                    <RemarksBgIcon />
                  </ButtonBase>
                </Box>
                <AutoCompleteSelect
                  itemList={specialtyMapping}
                  value={form.eaedSpecialtyDdlMap}
                  onChange={updateForm({ key: 'eaedSpecialtyDdlMap' })}
                  placeholder="Select from below"
                  disabled={disabledWardCalling}
                />
              </Box>
              <Box display="flex" flexDirection="column" pb="1.995rem" width="18rem" gridGap="0.62rem">
                <Box display="flex" alignItems="flex-end" justifyContent="space-between" pr="2.1rem">
                  <Text
                    color="#2E4469"
                    fontSize="1rem"
                    style={{ display: 'flex', alignItems: 'flex-end', height: '2.75rem' }}
                  >
                    eAED sub specialty mapping
                  </Text>
                  <ButtonBase onClick={() => setMapPopOpen(true)} disabled={disabledWardCalling}>
                    <RemarksBgIcon />
                  </ButtonBase>
                </Box>
                <AutoCompleteSelect
                  itemList={subSpecialtyMapping}
                  value={form.eaedSubSpecialtyTxtboxMap}
                  onChange={updateForm({ key: 'eaedSubSpecialtyTxtboxMap' })}
                  placeholder="Select from below"
                  disabled={disabledWardCalling}
                />
              </Box>
            </Box>
          </Box>
          {/* 先隐藏 */}
          {/* <Box
            className={classNames(classes.step, 'IsolationRoom')}
            display="flex"
            flexDirection="column"
            gridGap="1.25rem"
            pb="2.5rem"
          >
            <Text fontSize="1.25rem" color="#2E4469">
              Isolation room & cubicle type mapping
            </Text>
            <Box display="flex" gridGap="1.25rem">
              <Box display="flex" flexDirection="column" alignItems="flex-start" width="18rem" gridGap="0.62rem">
                <Text color="#2E4469" fontSize="1rem">
                  For case to: AIIR
                </Text>
                {isolroomCubtype.isolroomCubtypeA.map((item) => (
                  <StyleInput
                    value={item.subTypeName}
                    onChange={updateForm({ key: 'isolroomCubtypeA', id: item.id })}
                    width="18rem"
                    placeholder="Input data"
                    key={item.id}
                  />
                ))}
                <ButtonBase className={classes.btn} onClick={handleAddIsolroomCubtype('A')}>
                  <AddIcon className={classes.addIcon} /> Add Cubicle Type
                </ButtonBase>
              </Box>
              <Box display="flex" flexDirection="column" alignItems="flex-start" width="18rem" gridGap="0.62rem">
                <Text color="#2E4469" fontSize="1rem">
                  For case to: Reverse Isolation
                </Text>
                {isolroomCubtype.isolroomCubtypeR.map((item) => (
                  <StyleInput
                    value={item.subTypeName}
                    onChange={updateForm({ key: 'isolroomCubtypeR', id: item.id })}
                    width="18rem"
                    placeholder="Input data"
                    key={item.id}
                  />
                ))}
                <ButtonBase className={classes.btn} onClick={handleAddIsolroomCubtype('R')}>
                  <AddIcon className={classes.addIcon} /> Add Cubicle Type
                </ButtonBase>
              </Box>
              <Box display="flex" flexDirection="column" alignItems="flex-start" width="18rem" gridGap="0.62rem">
                <Text color="#2E4469" fontSize="1rem">
                  For case to: Single Room
                </Text>
                {isolroomCubtype.isolroomCubtypeS.map((item) => (
                  <StyleInput
                    value={item.subTypeName}
                    onChange={updateForm({ key: 'isolroomCubtypeS', id: item.id })}
                    width="18rem"
                    placeholder="Input data"
                    key={item.id}
                  />
                ))}
                <ButtonBase className={classes.btn} onClick={handleAddIsolroomCubtype('S')}>
                  <AddIcon className={classes.addIcon} /> Add Cubicle Type
                </ButtonBase>
              </Box>
            </Box>
          </Box> */}
          <Box
            className={classNames(classes.step, classes.yellow, hideStep)}
            display="flex"
            flexDirection="column"
            gridGap="1.25rem"
            pb="2.5rem"
          >
            <Text fontSize="1rem">Ward Acknowledged</Text>
            <Box display="flex" flexDirection="column" width="18rem" gridGap="0.62rem">
              <Text color="#2E4469" fontSize="1rem">
                Is ward acknowledged required <span className={classes.star}>*</span>
              </Text>
              <AutoCompleteSelect
                itemList={dropdownOptions.ynOptions}
                value={form.isWardAckReq}
                onChange={updateForm({ key: 'isWardAckReq' })}
                width="18rem"
                placeholder="Select from below"
                disabled={disabledWardCalling}
              />
            </Box>
          </Box>
          <Box
            className={classNames(classes.step, classes.yellowSolid, hideStep)}
            display="flex"
            flexDirection="column"
            gridGap="1.25rem"
            pb="2.5rem"
          >
            <Text fontSize="1.25rem" color="#2E4469">
              Ward Ready
            </Text>
            <Box display="flex" alignItems="flex-end" gridGap="1.25rem">
              <Box display="flex" flexDirection="column" alignItems="flex-start" width="18rem" gridGap="0.62rem">
                <Text color="#2E4469" fontSize="1rem">
                  Is ward ready required <span className={classes.star}>*</span>
                </Text>
                <AutoCompleteSelect
                  itemList={dropdownOptions.ynOptions}
                  value={form.isWardReadyReq}
                  onChange={updateForm({ key: 'isWardReadyReq' })}
                  width="18rem"
                  placeholder="Select from below"
                  disabled={disabledWardCalling}
                />
              </Box>
            </Box>
          </Box>
          <Box
            className={classNames(classes.step, classes.yellowSolid, hideStep)}
            display="flex"
            flexDirection="column"
            gridGap="1.25rem"
            pb="2.5rem"
          >
            <Text fontSize="1.25rem" color="#2E4469">
              Admission Registration
            </Text>
            <Box display="flex" alignItems="flex-end" gridGap="1.25rem">
              <Box display="flex" flexDirection="column" gridGap="0.62rem">
                <Text color="#2E4469" fontSize="1rem">
                  My hospital&apos;s Admission Officer unit <span className={classes.star}>*</span>
                </Text>
                <Box display="flex" alignItems="center" gridGap="1.19rem">
                  <AutoCompleteSelect
                    itemList={dropdownOptions.wardItemOptions}
                    value={form.admWardId}
                    onChange={updateForm({ key: 'admWardId' })}
                    width="18rem"
                    placeholder="Select from below"
                  />
                  <ButtonBase className={classes.btn} onClick={() => setAddUnit(true)}>
                    <AddIcon className={classes.addIcon} /> Add Unit
                  </ButtonBase>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            className={classNames(classes.step, classes.yellowSolid, hideStep)}
            display="flex"
            flexDirection="column"
            gridGap="1.25rem"
            pb="2.5rem"
          >
            <Text fontSize="1.25rem" color="#2E4469">
              Porter Dispatch
            </Text>
            <Box display="flex" alignItems="flex-end" gridGap="1.25rem">
              <Box display="flex" flexDirection="column" gridGap="0.62rem">
                <Text color="#2E4469" fontSize="1rem">
                  Porter Dispatch by <span className={classes.star}>*</span>
                </Text>
                <AutoCompleteSelect
                  itemList={dropdownOptions.porterListOptions}
                  value={form.porterDispatchBy}
                  onChange={updateForm({ key: 'porterDispatchBy' })}
                  width="18rem"
                  placeholder="Select from below"
                />
              </Box>
            </Box>
          </Box>
          <Box
            className={classNames(classes.step, classes.green, hideStep)}
            display="flex"
            flexDirection="column"
            gridGap="1.25rem"
            pb="2.5rem"
          >
            <Text fontSize="1rem">AED Discharged</Text>
            <Box display="flex" flexDirection="column" width="18rem" gridGap="0.62rem">
              <Text color="#2E4469" fontSize="1rem">
                Bus stop position<span className={classes.star}>*</span>
              </Text>
              <AutoCompleteSelect
                itemList={dropdownOptions.aedDischgPositionOptions}
                value={form.aedDischgPosition}
                onChange={updateForm({ key: 'aedDischgPosition' })}
                placeholder="Select from below"
              />
            </Box>
          </Box>
          <Box className={classNames(classes.step, classes.green, hideStep)} pb="2.5rem">
            <Text fontSize="1rem">
              {`Ward Arrival ( If "Porter Dispatch" is by "ADS" or "Hide", this will be visible. Otherwise, invisible. )${''}`}
            </Text>
          </Box>
          <Box
            className={classNames(classes.step, classes.green, 'hideStep')}
            display="flex"
            flexDirection="column"
            gridGap="1.25rem"
          >
            <Text fontSize="1rem">Bed Assigned</Text>
          </Box>
        </Box>
        <Box className={classes.completedBox}>
          <Text color="#2E4469" fontSize="1rem">
            Update case status to &quot;Completed&quot; at
          </Text>
          <AutoCompleteSelect
            itemList={dropdownOptions.caseStatusCompletedAtOptions}
            value={form.completed}
            onChange={updateForm({ key: 'completed' })}
            width="18rem"
            placeholder="Select from below"
          />
        </Box>
        {/* map弹窗 */}
        <MappingPopups open={mapPopOpen} handleClose={() => setMapPopOpen(false)} />
      </Dialog>
      {addUnit && <AddWardPop closePop={() => setAddUnit(false)} open={addUnit} confirmClick={addPopConfirmClick} />}
    </>
  );
};

export default EditWorkflow;
